import { StorageStepSchema } from '@feedyou/schema'

import { Search } from '../../../types'
import { createConfigs, searchMutableObject } from '../../../../../features/flowSearch'

export const search: Search<StorageStepSchema> = (step, query) => {
  return searchMutableObject(
    step,
    query,
    { type: 'step', id: step.id },
    createConfigs({
      id: ['id'],
      storage: ['storage'],
      text: ['value', 'valueTitle', 'condition']
    })
  )
}
